import './rSlider';


document.addEventListener('DOMContentLoaded', () => {
if (document.querySelector('.price-plan')) {
    console.log('Enter');
    let aCost = 0;
    let cCost = 0;
    const Base = 25;
    
    const aSlider = document.querySelector('#aNumber');
    const cSlider = document.querySelector('#cNumber');
    const priceTotal = document.querySelector('.price--total');
    const athletesPlan = document.querySelector('.athletes-plan');
    const coachesPlan = document.querySelector('.coaches-plan');
    
    
    function setAthleteNum(num) {
        athleteNumber.innerHTML = (num > 3) ? num : '';
    }
    
    function setCoachesNum(num) {
        const coachName = (num == 1) ? 'coach' : 'coaches';
        const coaches = [
            {
             text: 'additional coach'
            },
            {
             text: `${num} additional ${coachName}`
            }
         ]

         const c = (num <= 0 ) ? coaches[0] : coaches[1]; 
         coachesPlan.innerHTML = `<div class="wp-block-group addon-option has-purple-color has-text-color has-link-color wp-elements-5f338157faa74ba89e0e6eba271e63c6 is-nowrap is-layout-flex wp-container-core-group-is-layout-15 wp-block-group-is-layout-flex">
         <div class="wp-block-group label has-global-padding is-layout-constrained wp-block-group-is-layout-constrained">
         <p class="has-purple-color has-text-color has-link-color has-plain-font-size wp-elements-b183ad5a2995482ba7c575c0ac543bc4">${c.text}</p>
         </div> <p class="value has-plain-font-size " style="font-style:normal;font-weight:700"><span class="price">$15 </span> / mo per coach</p>
         </div>`;
    }
    
    function setAthletePlan(plan, number) {
       
        const plans = [
           {
            text: 'up to 3 Athletes',
            price: `<span class="price">Free</span>`
           },
           {
            text: `${number} athletes`,
            price: `<span class="price">$7</span> / mo per athlete`
           },
           {
            text: `${number} athletes`,
            price: `<span class="price">$6</span> / mo per athlete`
           },
           {
            text: `${number} athletes`,
            price: `<span class="price">$5</span> / mo per athlete`
           }
        ];
       
       
        athletesPlan.innerHTML = `<div class="wp-block-group addon-option 3athletes has-purple-color has-text-color has-link-color wp-elements-162ce8e39e1480656d028796e682753b is-nowrap is-layout-flex wp-container-core-group-is-layout-9 wp-block-group-is-layout-flex">
        <div class="wp-block-group label  is-layout-flow wp-container-core-group-is-layout-8 wp-block-group-is-layout-flow">
        <p class="has-dark-purple-color has-text-color has-link-color has-plain-font-size ">${plans[plan].text}</p>
        </div><p class="value has-plain-font-size " style="font-style:normal;font-weight:700">${plans[plan].price}</p>
        </div>`;
       
       

    }
    function calculateTotal() {
        const total = Base + aCost + cCost;
        priceTotal.innerHTML = `$${total}<sub>/mo</sub>`;
    }
    
    if (aSlider) {
        aSlider.addEventListener('input', function(e) {
            const val = parseInt(e.target.value, 10);
            if (val >= 4 && val <= 50) {
                
                aCost = 7 * (val - 3);
                setAthletePlan(1, val)
            } 
            else if (val >= 51 && val <= 100) {
                
                aCost = 6 * (val - 3);
                setAthletePlan(2, val)
            }
            else if (val >= 101 && val <= 200) {
                
                aCost = 5 * (val - 3);
                setAthletePlan(3, val)
                
            }
             else {
                aCost = 0;
                setAthletePlan(0, 0)
            }


            if (val > 180) {
                document.querySelector('.plus-athletes').classList.add('shown');
            } else{
                document.querySelector('.plus-athletes').classList.remove('shown');
            }
            
            calculateTotal();
        });
    }
    
    
    cSlider.addEventListener('input', function(e) {

        const val = parseInt(e.target.value, 10);
        if (val > 0) {
            cCost = 15 * val;
        } else {
            cCost = 0;
        }
        setCoachesNum(val);
        calculateTotal();
    });	
}

})